import { css } from 'lit';

export const bundleBuilderStyles = css`
  .bundle-wrapper {
    background-color: var(--light-color-1);
    border-top: 1px solid var(--gray-30);
    width: 100%;
    z-index: 40;
    transition: max-height var(--duration-600ms) ease-in-out;

    &.hidden {
      visibility: hidden;
      max-height: 0;
      overflow: hidden;
    }

    &.visible {
      visibility: visible;
      max-height: none;
    }
  }

  .bundle-notifications-wrapper {
    align-items: center;
    background-color: transparent;
    bottom: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    left: 50%;
    padding: var(--space-3);
    position: absolute;
    transform: translateX(-50%);
  }

  .notification-wrapper {
    background-color: var(--brand-color-1);
    color: var(--light-color-1);
    font-size: var(--font-size-b2);
    font-weight: var(--font-weight-bold);
    line-height: var(--font-size-b2);
    padding: var(--space-3) var(--space-4);
    text-transform: uppercase;
    width: max-content;

    &.discount-type {
      align-items: center;
      color: #5f513d;
      background-color: var(--brand-color-3);
      display: flex;
      gap: var(--space-2);
    }

    &.error {
      background-color: var(--brand-color-2);
    }
  }

  .inner-wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    justify-content: space-between;
    margin: 0 auto;
    padding: var(--space-4);
    max-width: calc(var(--max-width) - 96px);

    @media (min-width: 1100px) {
      flex-direction: row;
      gap: var(--space-4);
      padding: var(--space-2) var(--section-space-horizontal);
    }
  }

  .box-information-wrapper {
    align-self: flex-start;
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: var(--space-4);
    width: calc(100% - var(--safe-space-right));

    @media (max-width: 640px) {
      justify-content: space-between;
    }

    @media (min-width: 1100px) {
      gap: var(--space-2);
      width: auto;
      align-self: unset;
    }
  }

  .box-information-inner-wrapper {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: var(--space-4);
    width: 100%;

    @media (max-width: 640px) {
      justify-content: flex-start;
    }
  }

  .box-icon {
    width: 24px;
  }

  .box-count {
    font-size: 14px;
    font-weight: 700;
    line-height: 120%;
  }

  .slots-filled-label {
    font-size: 11px;
    font-weight: 600;
    line-height: 120%;
    text-transform: uppercase;
    width: 80px;
  }

  .slots-filled-data {
    font-size: 32px;
    font-weight: 600;
    line-height: 120%;
  }

  .bundle-builder-size-toggle {
    background: none;
    border: none;
    cursor: pointer;
    outline: none;

    @media (min-width: 1100px) {
      display: none;
    }
  }

  .toggle-state-icon {
    transition: transform 500ms linear;
  }

  .icon-collapse {
    transform: rotate(180deg);
  }

  .icon-expand {
    transform: rotate(0deg);
  }

  .product-grid-outer-wrapper {
    flex: 0 1 auto;
    width: 100%;

    &.expanded {
      display: block;
    }

    &.contracted {
      display: none;
      @media (min-width: 1100px) {
        display: block;
      }
    }

    @media (min-width: 1100px) {
      width: auto;
    }
  }

  .bundle-items-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-1);
    list-style: none;
    margin: 0;
    overflow: visible;
    padding: 0;

    @media (max-width: 640px) {
      justify-content: center;
    }

    @media (min-width: 640px) and (min-width: 1099px) {
      justify-content: flex-start;
    }
  }

  .bundle-item {
    display: flex;
    flex-direction: column;
    position: relative;

    &.destroy {
      transition:
        opacity 300ms ease-in,
        width 10ms linear 300ms;
      opacity: 0;
    }
  }

  .image-wrapper {
    height: 68px;
  }

  .product-image {
    height: 68px;
    object-fit: contain;
    width: 62px;

    &.placeholder {
      height: 66px;
      object-fit: cover;
      border: 1px dashed #adadad;
    }
  }

  .remove-item-button,
  .product-quantity {
    align-items: center;
    background-color: var(--dark-color-1);
    border-radius: 50%;
    color: var(--light-color-1);
    display: flex;
    font-size: 12px;
    font-weight: 700;
    height: 26px;
    justify-content: center;
    position: absolute;
    right: 2px;
    top: 3px;
    width: 26px;
  }

  .remove-item-button {
    border: none;
    cursor: pointer;
    height: 24px;
    right: 3px;
    text-decoration: none;
    text-transform: uppercase;
    top: 4px;
    width: 24px;
  }

  .quantity-selector {
    margin-top: var(--space-1);
    margin-bottom: var(--space-2);
    padding: 5px 0;
    text-align: center;
  }

  .actions-wrapper {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    gap: var(--space-6);
    overflow-y: hidden;
    width: 100%;

    &.expanded {
      display: flex;
    }

    &.contracted {
      display: none;

      @media (min-width: 1100px) {
        display: flex;
        margin-right: calc(var(--safe-space-right));
      }
    }

    @media (min-width: 1100px) {
      width: auto;
      justify-content: flex-end;
    }
  }

  .action-links-wrapper {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: var(--space-6);
  }

  .secondary-action-button {
    background: none;
    border: none;
    color: var(
      --brand-color-1
    ); /* No longer matches the figma design to make actionable buttons look like they are clickable */
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    text-transform: uppercase;

    &:hover {
      color: var(--dark-color-1);
      text-decoration: underline;
    }
  }

  .apply {
    color: var(--dark-color-1);
    text-decoration: underline;
  }

  .add-to-cart-button {
    background-color: var(--brand-color-1);
    color: var(--light-color-2);
    border: 1px solid var(--dark-color-1);
    border-radius: var(--border-radius-3);
    cursor: pointer;
    font-size: 14px;
    font-weight: var(--font-weight-medium);
    padding: var(--space-1) var(--space-6);
    text-transform: uppercase;

    &:hover {
      background-color: var(--brand-color-1-tint);
    }

    &:disabled {
      background: var(--light-color-1);
      border-color: var(--mono-color-1);
      color: var(--mono-color-1);
      cursor: not-allowed;
    }

    &:focus-visible {
      outline: none;

      &::after {
        content: '';
        inset: 0;
        outline: 2px solid var(--brand-color-3);
        outline-offset: 4px;
        position: absolute;
      }
    }

    &.btn-loading {
      align-items: center;
      background-color: var(--brand-color-1);
      color: transparent;
      display: flex;
      justify-content: center;
      height: 100%;
      padding: var(--space-1) var(--space-6);
      width: 100%;

      &::after {
        animation: spin 2s linear infinite;
        border: 2px solid var(--light-color-1);
        border-radius: 50%;
        border-top-color: var(--gray-500);
        content: '';
        display: block;
        height: 1rem;
        position: absolute;
        width: 1rem;
      }
    }

    &.btn-success {
      background-color: var(--light-color-1);
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none"><path d="M5.97297 11L0.5 5.56791L1.98646 4.07407L5.97297 8.14814L14.0135 0L15.5 1.49383L5.97297 11Z" fill="%231A142E"/></svg>');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 1.375rem;
      color: transparent;
      height: 100%;
      padding: var(--space-1) var(--space-6);
      width: 100%;
    }

    &.btn-error {
      border-color: var(--brand-color-2);
      color: var(--brand-color-2);
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
